import { SET_TENANT_CONFIG, SET_TENANT_CAREERS } from '../actionTypes';

const getInitialState = () => ({
  id: '',
  primary: '',
  secondary: '',
  error: '',
  hero: '',
  heroImgPortrait: '',
  logo: '',
  name: '',
  terms_info: {},
  features: '',
  logoLink: '',
  additionalLogoLink: '',
  allTenantCareers: [],
  showCampus: false,
});

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case SET_TENANT_CONFIG: {
      const {
        id,
        primary,
        secondary,
        error,
        hero,
        heroImgPortrait,
        logo,
        name,
        terms_info,
        features,
        logoLink,
        dashboardHero,
        additionalLogoLink,
        buttonInfo,
        published,
        showCampus,
      } = action.payload;

      return {
        ...state,
        id,
        primary,
        secondary,
        error,
        hero,
        heroImgPortrait,
        logo,
        name,
        terms_info,
        features,
        logoLink,
        dashboardHero,
        additionalLogoLink,
        buttonInfo,
        published,
        showCampus,
      };
    }

    case SET_TENANT_CAREERS: {
      const { allTenantCareers } = action.payload;

      return {
        ...state,
        allTenantCareers,
      };
    }

    default:
      return state;
  }
}
